import axios from "axios";
import store from "../store";

class Elements {
	async rename(type, name, new_name) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/element/rename",
					{
						type,
						name,
						new_name,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async save(name, version, data, type, env, data_db = {}) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/element/save",
					{
						name,
						version,
						data,
						type,
						env,
						data_db,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async load(name, version, type) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/element/load",
					{
						name,
						version,
						type,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getby_production(type, libelle = null, share = true) {
		let jwt = store.state.jwt;

		// console.log("getby_production")

		var body = { type, share };
		if (libelle) body.libelle = libelle;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/element/getby_production",
					body,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getby_libelle(name, type) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/element/getby_libelle",
					{
						name,
						type,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Elements();
